import { render, staticRenderFns } from "./ManuscriptPolishing.vue?vue&type=template&id=9b6c334e&scoped=true"
import script from "./ManuscriptPolishing.vue?vue&type=script&lang=js"
export * from "./ManuscriptPolishing.vue?vue&type=script&lang=js"
import style0 from "./ManuscriptPolishing.vue?vue&type=style&index=0&id=9b6c334e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6c334e",
  null
  
)

export default component.exports